import { flashSuccess } from '/app/app/assets/js/utils/flash.js'

export default (value, message) => ({
  copy() {
    navigator.clipboard.writeText(value)
    flashSuccess(message)
  },
})
